import { Model } from '@vuex-orm/core';
import { InvoiceEmail } from '@/interfaces/components/clients/InvoiceEmail';
import ClientEmailAPI from '@/api/ClientEmailAPI';

export default class ClientEmail extends Model {
    public static entity = 'ClientEmail';

    public static fields() {
        return {
            id: this.attr(null),
            email: this.string(''),
            emailType: this.string(''),
            createdAt: this.string(''),
            updatedAt: this.string(''),
        };
    }

    public static async getAll(id: string) {
        let ClientEmails;
        try {
            ClientEmails = await ClientEmailAPI.getAll(id);
        } catch (e) {
            return Promise.reject(e);
        }
        this.create({
            data: ClientEmails.data,
        });
        return Promise.resolve();
    }

    public static async updateExisting(ClientEmailInfo: InvoiceEmail, clientId: string) {
        let ClientEmail;
        try {
            ClientEmail = await ClientEmailAPI.update(ClientEmailInfo, clientId);
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(ClientEmail);
    }

    public static async createNew(ClientEmailInfo: InvoiceEmail, clientId: string) {
        let ClientEmail;
        try {
            ClientEmail = await ClientEmailAPI.create(ClientEmailInfo, clientId);
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(ClientEmail);
    }

    public static async deleteExisting(ClientEmailId: string) {
        try {
            await ClientEmailAPI.delete(ClientEmailId);
        } catch (e) {
            return Promise.reject(e);
        }
        await ClientEmail.delete(ClientEmailId);
        return Promise.resolve();
    }

    public id!: string;
    public email!: string;
    public emailType!: string;
    public createdAt!: string;
    public updatedAt!: string;
}
